export default "__VITE_ASSET__CPtFZWjy__"